import { useEffect, useState } from 'react';
import { MailCheck } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { INPUT_CLS, ERROR_CLS } from '@/components/brand/BrandKit';
import { AuthShell, AuthLink, Field } from '@/components/account/AuthShell';
import { forgotPassword, apiError } from '@/api/account';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => { document.title = 'Reset password | Eurogulf Mobility Group'; }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(apiError(err, 'Could not send the reset link. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="forgot-page" eyebrow="Password help" title="Forgot your password?" lead="Enter the email on your account and we will send you a link to choose a new password."
      footer={<>Remembered it? <AuthLink to="/login" testid="forgot-to-login">Back to sign in</AuthLink></>}>
      {sent ? (
        <div data-testid="forgot-success" className="text-center py-4">
          <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#FFF4ED] text-[#EE5A01]"><MailCheck className="w-8 h-8" /></span>
          <h2 className="mt-5 font-heading font-black text-2xl text-[#121212]">Check your inbox</h2>
          <p className="mt-2 font-body text-sm text-[#666666]">If an account exists for <span className="font-bold text-[#121212]">{email}</span>, a reset link is on its way. It stays valid for 60 minutes.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" noValidate>
          {error && <p data-testid="forgot-error" role="alert" className={ERROR_CLS}>{error}</p>}
          <Field label="Email" htmlFor="forgot-email">
            <Input id="forgot-email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" autoComplete="email" className={INPUT_CLS} required />
          </Field>
          <button type="submit" data-testid="forgot-submit" disabled={loading || !email} className="btn-primary w-full disabled:opacity-50">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
